import * as tslib_1 from "tslib";
import { CommandContainer } from './command_container';
var ToolBar = /** @class */ (function (_super) {
    tslib_1.__extends(ToolBar, _super);
    function ToolBar(param) {
        return _super.call(this, param) || this;
    }
    ToolBar.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "ToolBar" });
    };
    ToolBar.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ToolBar;
}(CommandContainer));
export { ToolBar };
//# sourceMappingURL=toolbar.js.map